import React from "react";
import { useSelector } from "react-redux";
import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import { CheckboxInputValidationAware } from "components/inputs";
import Section from "components/items/section";
import { getReferralFormLayoutSetting, getAcknowledgementStatement } from "app/auth/store/reducers/system-configuration";

const useStyles = makeStyles(() => ({
  boldStatement: {
    fontWeight: "bold",
  },
}));

const AcknowledgementSection = ({
  fieldSettings,
  // true: we are editing an existing referral.
  // false: we are creating a new referral
  isEdit,
  readOnlyInEditMode = true,
}) => {
  const classes = useStyles();
  const sectionTitle = "Acknowledgement";
  const acknowledgementStatement = useSelector(getAcknowledgementStatement);
  const referralFormLayoutSetting = useSelector(getReferralFormLayoutSetting);
  const isBallaratProduct = referralFormLayoutSetting === "Layout2";

  if (!isBallaratProduct) {
    return null;
  }

  // Display this field as read-only when editing an existing referral.
  const isDisabled = isEdit && readOnlyInEditMode;
  // Only require acknowledgement for new referrals when the field setting requires it
  const isRequired = !isEdit && fieldSettings?.acknowledgement?.required;

  return (
    <Section withDivider title={sectionTitle}>
      <Field
        name="referral.isAcknowledged"
        component={CheckboxInputValidationAware}
        label={<span className={classes.boldStatement}>{acknowledgementStatement}</span>}
        showHelperText
        required={isRequired}
        disabled={isDisabled}
      />
    </Section>
  );
};

export default AcknowledgementSection;
